


















































































































































































































import Vue from 'vue';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

import ItemFormDialog from '@/components/item/ItemFormDialog.vue';
import UploadItemDialog from '@/components/item/UploadItemDialog.vue';
import ConfirmDialog from '@/components/core/ConfirmDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

import { ErrorManager } from '@/models/error';
import { IItem, IPriceSnapshot, Item } from '@/models';

import { IFetchItemsActionPayload } from '@/store/item';
import { createDownloadFile } from '@/utils/helpers';
import { DataTableHeader } from 'vuetify';
import ALPage from '@/components/core/Page/ALPage.vue';

export default Vue.extend({
  components: {
    ItemFormDialog,
    UploadItemDialog,
    ConfirmDialog,
    ErrorAlert,
    ALPage
  },

  data() {
    return {
      search: '',
      loading: false,

      errorMessage: '',
      detailErrorMessage: '',

      options: {
        showFirstLastPage: true,
        itemsPerPageOptions: [100]
      },
      page: 1,

      actionLoading: false
    };
  },

  computed: {
    ...mapGetters({
      items: 'item/getItems',
      itemCount: 'item/getItemCount',
      getPriceSnapshotById: 'priceSnapshot/getPriceSnapshotById'
    }),

    snapshotQuery(): number | undefined {
      const snapshot = Number(this.$route.query.snapshot);
      if (isNaN(snapshot)) return undefined;
      return snapshot;
    },

    snapshot(): IPriceSnapshot {
      return this.getPriceSnapshotById(this.snapshotQuery);
    },

    itemHeaders(): DataTableHeader[] {
      const headers: DataTableHeader[] = [
        {
          text: '',
          value: 'icons',
          sortable: false,
          width: 50
        },
        {
          text: 'Item',
          align: 'start',
          sortable: false,
          value: 'item',
          width: 150
        },
        {
          text: 'Description',
          value: 'description',
          width: 300,
          sortable: false
        },
        {
          text: 'ABC Code',
          value: 'abc_code',
          align: 'center',
          width: 110,
          sortable: false
        },
        {
          text: 'Family Code',
          value: 'family_code',
          width: 120,
          sortable: false
        },
        {
          text: 'Unit Cost (CAD)',
          value: 'unit_cost',
          align: 'end',
          width: 140,
          sortable: false
        },
        {
          text: 'U/M',
          value: 'unit',
          width: 90,
          sortable: false
        },
        {
          text: 'Last Gen Date',
          value: 'last_gen_date',
          width: 160,
          sortable: false
        },
        {
          text: 'Unit Price (USD)',
          value: 'price',
          align: 'end',
          width: 140,
          sortable: false
        },
        {
          text: 'HS Code',
          value: 'hs_code',
          width: 140,
          sortable: false
        },
        {
          text: 'COO',
          value: 'country_of_origin',
          width: 90,
          sortable: false
        },
        {
          text: 'Phantom',
          value: 'is_phantom',
          width: 100,
          sortable: false
        }
      ];
      if (!this.snapshot) {
        headers.push({
          text: '',
          value: 'actions',
          sortable: false,
          width: 100
        });
      }
      return headers;
    }
  },

  watch: {
    search(newSearch: string, prevSearch: string) {
      if (newSearch !== prevSearch) {
        this.page = 1; //called fetchdata
        this.fetchItemResults(this.page, newSearch, this.snapshotQuery);
      }
    },

    page: {
      handler(val) {
        this.fetchItemResults(val, this.search, this.snapshotQuery);
      }
    },

    '$route.query': {
      handler(val) {
        this.fetchItemResults(this.page, this.search, this.snapshotQuery);
      },
      deep: true
    }
  },

  mounted() {
    this.fetchItemResults(this.page, this.search, this.snapshotQuery);
    if (this.snapshotQuery) {
      this.fetchPriceSnapshot(this.snapshotQuery);
    }
  },

  methods: {
    ...mapActions({
      fetchItems: 'item/fetchItems',
      deleteItem: 'item/deleteItem',
      exportItems: 'item/exportItems',

      fetchPriceSnapshot: 'priceSnapshot/fetchPriceSnapshot'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    exportItemList() {
      this.clearAllErrors();
      this.actionLoading = true;
      this.exportItems()
        .then((data: Blob) => {
          createDownloadFile(
            data,
            `items-${moment(new Date()).format('YYYY-MM-DD-HH-mm-ss')}.xlsx`
          );
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.actionLoading = false;
        });
    },

    createItem() {
      (this as any).$refs.ItemFormDialog.open();
    },

    updateItem(item: Item) {
      (this as any).$refs.ItemFormDialog.open(item, true);
    },

    itemDetailClass(item: IItem) {
      if (item.is_obsolete) {
        return 'item-row--disabled';
      }
    },

    fetchItemResults(page: number, search?: string, snapshot?: number) {
      const params = {
        page,
        search,
        snapshot
      } as IFetchItemsActionPayload;

      this.loading = true;
      this.fetchItems(params)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    },

    async deleteRecord(item: Item) {
      const confirm = (this as any).$refs.confirm;
      if (
        await confirm.open(
          'Delete Item',
          {
            left: {
              text: 'No'
            }
          },
          `<span style="line-height: 19px;">Are you sure you want to delete <strong class="text--primary" style="word-break: normal">${item.item}</strong>? <br /> This action cannot be undone.</span>`
        )
      ) {
        this.loading = true;
        this.deleteItem(item.item)
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => (this.loading = false));
      }
    }
  }
});
